import { Theme, ThemeOptions } from '@mui/material';
import material3 from '../material3';

export const getTextFieldOverrides = (theme: Theme): ThemeOptions['components'] => {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '12px 14px'
        },
        root: {
          background: material3.color.surfaceContainerLow,
          borderRadius: material3.shape.medium,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: material3.color.outline
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
            borderWidth: '2px'
          }
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: '12px 14px'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: material3.color.textSecondary,
          top: '-4px',
          fontWeight: material3.typography.bodyWeight
        },
        shrink: {
          top: '0px',
          transition: '.15s ease'
        }
      }
    }
  };
};
